import { heroSwiper, testimonialsSwiper } from './homePage';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import throttle from './helpers/throttle';
import sauron from './helpers/observatory';
import { headerJs } from './header';

headerJs()


const testimonialSwiperTarget = document.querySelector(".testimonial-swiper")
function testimonialsCaller() {
    testimonialsSwiper()
}

testimonialSwiperTarget && sauron(testimonialSwiperTarget, testimonialSwiperTarget.dataset.id, testimonialsCaller)

quotesSwiper()

export function quotesSwiper() {
    let BlockWithQuotesSwiper;
    let swiperInit = false;

    // function to get the window width
    const windowWidth = () => window.innerWidth;

    // function that checks if the window width is bigger or smaller that 640px and adds true/false to the function that initializes or destroys the swiper
    function initBlockWithQuotesSwiper() {
        if (windowWidth() < 640) {
            blockWithQuotesSwiper(false)
        } else {
            blockWithQuotesSwiper(true)
        }
    }

    // We run once the function to initialize if needed the swiper
    initBlockWithQuotesSwiper()

    // We observe the window resize and we check if the swiper should be destroyed or initialized
    window.addEventListener('resize', throttle(function () {
        initBlockWithQuotesSwiper()
    }, 1000))


    // function that if destroy is false we initialize swiper else we destroy it.
    function blockWithQuotesSwiper(destroy) {
        if (!destroy) {
            if (!swiperInit) {
                BlockWithQuotesSwiper = new Swiper(".blockWithQuotesSwiper", {
                    pagination: {
                        el: ".custom-swiper-pagination",
                    },
                })
            }
            swiperInit = true
        } else {
            swiperInit && typeof BlockWithQuotesSwiper !== "undefined" && BlockWithQuotesSwiper.destroy()
            swiperInit = false
        }
    }

}
